import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import ProtectedRoute from './components/ProtectedRoute';
import Dashboard from './pages/Dashboard';
import Report from './pages/Report';
import ReportGenerator from './pages/ReportGenerator';
import EDRManagement from './pages/EDRManagement';
import Login from './pages/Login';

function App() {
  const location = useLocation();
  const isLoginRoute = location.pathname === '/login';

  return (
    <AuthProvider>
      <div className="App">
        <Navigation />
        <main className={isLoginRoute ? 'app-route-shell app-route-shell-login' : 'app-route-shell'}>
          <Routes future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Navigate to="/dashboard" replace />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/report" element={
              <ProtectedRoute>
                <Report />
              </ProtectedRoute>
            } />
            <Route path="/generate-report" element={
              <ProtectedRoute>
                <ReportGenerator />
              </ProtectedRoute>
            } />
            <Route path="/edr-management" element={
              <ProtectedRoute>
                <EDRManagement />
              </ProtectedRoute>
            } />
          </Routes>
        </main>
      </div>
    </AuthProvider>
  );
}

export default App;
